var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorneDIstanceC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_621_1471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 237,
    height: 237
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.01 0.264648H7.01001V236.265H243.01V0.264648Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_621_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.24 184.135V172.935L65.16 196.475V210.045L21.24 184.135Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.55 197.755L21.24 172.955L188.68 73.8247L228.78 93.6548L65.55 197.755Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.02 210.365V197.105L228.78 93.5347V104.965L65.02 210.365Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.86 163.715L31.47 166.885L59.17 182.155L64.8 178.625L36.86 163.715Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0399 147.025L59.6499 150.205L87.3399 165.495L92.9699 161.965L65.0399 147.025Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.36 155.725L45.77 158.455L63.91 167.475L68.79 164.365L50.36 155.725Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.42 129.625L89.04 132.825L116.81 147.975L122.42 144.415L94.42 129.625Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92 113.285L116.56 116.515L144.41 131.505L150.01 127.915L121.92 113.285Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.12 122.125L102.52 124.835L120.61 133.955L125.51 130.865L107.12 122.125Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58 96.9746L144.18 100.145L171.86 115.455L177.49 111.935L149.58 96.9746Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68 80.3347L172.3 83.5247L200.05 98.7046L205.67 95.1548L177.68 80.3347Z",
    fill: "#FECECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67 89.2246L158.07 91.9446L176.2 101.005L181.08 97.9048L162.67 89.2246Z",
    fill: "#FECECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3 105.395L130.69 108.095L148.77 117.245L153.67 114.175L135.3 105.395Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2399 139.185L73.6699 141.945L91.8599 150.865L96.7199 147.725L78.2399 139.185Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.13 42.8147C174.34 37.2847 175.97 34.9847 175.97 31.5347C175.97 26.0247 171.58 24.1147 166.96 24.1147C164.25 24.1147 161.92 24.7846 159.89 25.7546L160.54 30.4148C161.74 29.7148 164.28 28.9646 166.34 28.9646C168.4 28.9646 170.13 29.5446 170.13 31.9446C170.13 33.5646 169.26 35.1546 167.44 36.7546L159.69 43.5347V47.6248H176.63V42.8147H167.13Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.73 36.2146C178.73 42.7846 181.73 47.9646 188.88 47.9646C196.03 47.9646 199.01 42.7846 199.01 36.2146C199.01 30.0846 196.3 24.1147 188.88 24.1147C181.46 24.1147 178.73 29.6246 178.73 36.2146ZM184.27 36.0247C184.27 32.5647 185.48 28.9846 188.88 28.9846C192.28 28.9846 193.47 32.3047 193.47 36.0247C193.47 39.4747 192.27 43.1047 188.88 43.1047C185.49 43.1047 184.27 39.7447 184.27 36.0247Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41 47.6248H228.78V36.9846C228.78 32.9846 225.8 30.9048 222.64 30.9048C220.58 30.9048 218.46 31.7648 217.13 33.6348C216.26 31.8248 214.16 30.9048 211.98 30.9048C210.05 30.9048 208.07 31.5046 206.91 32.9746L206.74 31.2446H201.81V47.6248H207.19V38.5146C207.19 36.6946 208.57 35.8247 209.91 35.8247C211.25 35.8247 212.59 36.6946 212.59 38.5146V47.6248H217.97V38.5146C217.97 36.6946 219.38 35.8247 220.73 35.8247C222.08 35.8247 223.41 36.6946 223.41 38.5146V47.6248Z",
    fill: "#F97E73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorneDIstanceC);
export default __webpack_public_path__ + "static/media/borneDIstanceC.835342ac3753815f2975c9e721c08fed.svg";
export { ForwardRef as ReactComponent };